import { jsx as n } from "react/jsx-runtime";
import { memo as c } from "react";
import _ from "clsx";
import { useModalContext as s } from "./ModalContext.js";
import '../../_assets/ModalFooter.Cnw2YkuD.css';const d = "_footer_52i1c_44", a = "_noDivider_52i1c_60", m = "_center_52i1c_64", f = "_centerLarge_52i1c_65", e = {
  footer: d,
  noDivider: a,
  center: m,
  centerLarge: f,
  "slide-in-out": "_slide-in-out_52i1c_1",
  "fade-in-out": "_fade-in-out_52i1c_1"
}, l = c(({ children: r, className: t }) => {
  const { mode: o, noDivider: i } = s();
  return /* @__PURE__ */ n(
    "div",
    {
      className: _(
        e.footer,
        {
          [e.center]: o === "center",
          [e.centerLarge]: o === "centerLarge",
          [e.noDivider]: i
        },
        t
      ),
      children: r
    }
  );
});
l.displayName = "ModalFooter";
export {
  l as ModalFooter
};
